export const environment = {
  production: true,
  cloud_api_url: 'https://prod-ablegatewayv2.able-plus.co.uk/cloud-api',
  idam_api_url: 'https://prod-ablegatewayv2.able-plus.co.uk/idam-api',
  mdx_api_url: 'https://staging-mdxv2.able-plus.co.uk:8081/able-mdx',
  default_return_url: 'https://able-plus.co.uk/my-resources',
  identityCookieUrl: 'https://idpcorev2.able-plus.co.uk',
  organisation_id: '',
  workflow_api_url: 'https://prod-ablegatewayv2.able-plus.co.uk/workflow-api',
  gateway_api_url: 'https://prod-ablegatewayv2.able-plus.co.uk',
  saml_api_url: 'https://staging-saml-sp-api.able-plus.co.uk',
  oauth2_api_url: 'https://newera-auth-staging.able-plus.co.uk',
};
